import {createRouter, createWebHistory} from 'vue-router'
import CarView from "@/views/Cars/CarView.vue";
import SignView from "@/views/Auth/SignView.vue";
import SignUpView from "@/views/Auth/SignUpView.vue";
import ConfirmView from "@/views/Auth/ConfirmView.vue";
import ResetPasswordView from "@/views/Auth/ResetPasswordView.vue";
import ForgotView from "@/views/Auth/ForgotView.vue";
import ProfileView from "@/views/ProfileView.vue";
import UserCarRequestView from "@/views/UserCarRequests/UserCarRequestView.vue";
import AboutView from "@/views/AboutView.vue";
import ExportGuideView from "@/views/ExportGuideView.vue";
import CarsView from "@/views/Cars/CarsView.vue";
import AdminCarRequestsView from "@/views/AdminCarRequests/AdminCarRequestsView.vue";
import AdminCarRequestView from "@/views/AdminCarRequests/AdminCarRequestView.vue";
import AccountantClientsView from "@/views/Accountant/AccountantClientsView.vue";
import AccountantClientView from "@/views/Accountant/AccountantClientView.vue";

export const router = createRouter({
    history: createWebHistory(),
    routes: [
        //AuthViews
        {
            path: '/sign',
            name: 'sign-in',
            component: SignView,
            props: true
        },
        {
            path: '/signup',
            name: 'sign-up',
            component: SignUpView,
            props: true
        },
        {
            path: '/confirm',
            name: 'confirm',
            component: ConfirmView,
            props: true
        },
        {
            path: '/forgot',
            name: 'forgot-password',
            component: ForgotView,
            props: true
        },
        {
            path: '/reset-password',
            name: 'reset-password',
            component: ResetPasswordView,
            props: true
        },

        //ProfileView
        {
            path: '/profile',
            name: 'profile',
            component: ProfileView
        },

        //CarsView
        {
            path: '/',
            name: 'home',
            component: CarsView
        },
        {
            path: '/cars/:id',
            name: 'car-view',
            component: CarView,
            props: true
        },

        //CarRequestView
        {
            path: '/car-requests/:id',
            name: 'car-request-view',
            component: UserCarRequestView,
            props: true
        },

        //AdminCarRequestsView
        {
            path: '/admin/car-requests',
            name: 'admin-car-requests-view',
            component: AdminCarRequestsView,
            props: true
        },
        {
            path: '/admin/car-requests/:id',
            name: 'admin-car-request-view',
            component: AdminCarRequestView,
            props: true
        },

        //AdminCarRequestsView
        {
            path: '/accountant/clients',
            name: 'accountant-clients-view',
            component: AccountantClientsView,
            props: true
        },
        {
            path: '/accountant/clients/:id',
            name: 'accountant-client-view',
            component: AccountantClientView,
            props: true
        },

        //ExportGuide
        {
            path: '/export-guide',
            name: 'export-guide',
            component: ExportGuideView,
            props: true
        },

        //About
        {
            path: '/about',
            name: 'about',
            component: AboutView,
            props: true
        },
    ]
});